import React from 'react';
import PropTypes from 'prop-types';

import { icons } from 'src/constants';

import './styles.scss';

// icons list: https://thermoux.s3.amazonaws.com/komodo-icons.css
const Icon = ({ name, size = 16, color = 'black', disabled }) => {
  let iconClassName = `icon-${size}-${name}`;

  if (!name) {
    return null;
  }

  if (color) {
    iconClassName = `${iconClassName} icon-${color}`;
  }

  if (disabled) {
    iconClassName = `${iconClassName} icon-disabled`;
  }

  return <span className={iconClassName} />;
};

Icon.propTypes = {
  name: PropTypes.string,
  size: PropTypes.oneOf(icons.ALLOWED_ICON_SIZES),
  color: PropTypes.oneOf(icons.ALLOWED_ICON_COLORS),
  disabled: PropTypes.bool
};

export default Icon;
